import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { FilePurposeValidationSchema } from './create';

const IMAGE_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];

export const UploadedFileResponseValidationSchema = z
  .object({
    id: z.string().meta({
      description: 'Unique File ID',
      example: '507f1f77bcf86cd799439011',
    }),
    location: z.url().meta({
      description: 'S3 URL of the file',
      example:
        'https://checkoutpage-images.s3.amazonaws.com/a3f2b1c4d5e6f7g8h9i0j1k2l3m4n5o6_product-image.jpg',
    }),
    name: z.string().meta({
      description: 'File name',
      example: 'product-image.jpg',
    }),
    purpose: FilePurposeValidationSchema.meta({
      description: 'Whether the uploaded asset is a public image or a private downloadable file.',
    }),
    type: z.string().meta({
      description: `MIME type - supports ${IMAGE_MIME_TYPES.join(', ')}`,
      example: 'image/jpeg',
    }),
    size: z.number().meta({
      description: 'File size in bytes',
      example: 245678,
    }),
    width: z.number().optional().meta({
      description: 'Image width in pixels (only for images)',
      example: 1920,
    }),
    height: z.number().optional().meta({
      description: 'Image height in pixels (only for images)',
      example: 1080,
    }),
    createdAt: z.string().meta({
      description: 'Creation timestamp',
      example: '2026-02-24T12:00:00.000Z',
    }),
  })
  .meta({
    id: 'UploadFileResponse',
  });

export const UploadFileResponseValidationSchema = z.object({
  data: UploadedFileResponseValidationSchema,
});
